<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AdminForm from '@/components/admin/AdminForm.vue'
import AdminMesureTypeForm from '@/components/admin/mesureType/AdminMesureTypeForm.vue'
import { AloDbMesureType } from '@/models/alodb/AloDbMesureType'
import { SecurityItemsKeys } from '@/enum/SecurityItems'


@Component({
  name: 'AdminMesureType',
  components: {AdminMesureTypeForm}
})
export default class AdminMesureType extends AdminForm<AloDbMesureType> {    

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_MESURETYPE].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }
  
  get itemTypeName() {
    return "MesureType"
  }

  get originalLibelle() {
    return this.original.MET_LIBELLE
  }

}
</script>